import Component from "./DropZoneButtonComponent";
export default Component;
